import DetailsBasel from "pages/Application/ExportLicense/DetailsBasel"
import Details from "pages/Application/ExportLicense/DetailsBasel"
import BaseApplication from "pages/BaseApplication"
import { useEffect, useState } from "react"
import OfficerForm from "../Forms/ReviewOfficer.form"
import DetailsPlasticBags from "../../PlasticBags/DetailsPlasticBags"
import DisposalDetails from "pages/Application/Disposal/DisposalDetails"
import Application from "services/applications/Application.service"

// 2024 services
import DetailsDeliveryPartner from "../../DeliveryPartner/Details"
import DetailsAccreditation from "../../AccreditationRequest/Details"
import DetailsNoObjection from "pages/Application/NoObjectionRequest/Details"
import DetailsEnvironmentalAudit from "../../EnvironmentalAudit/Details"

let officerInfo = JSON.parse(localStorage.getItem("authUser"))
let appService = new Application(officerInfo)

import ReviewController from "controllers/ReviewController"
import DetailsRotterdam from "pages/Application/ExportLicense/DetailsRotterdam"
import OfficerFormLicense from "../Forms/ReviewOfficerLicense.form"
import OfficerFormDeliveryPartner from "../Forms/ReviewOfficerDeliveryPartner.form"
import OfficerFormAccreditation from "../Forms/ReviewOfficerAccreditation.form"
import OfficerFormNoObjection from "../Forms/ReviewOfficerNoObjection.form"
import OfficerFormEnvironmentalAudit from "../Forms/ReviewOfficerEnvironmentalAudit.form"

const reviewController = new ReviewController()

const ReviewOfficerExport = props => {
  const [details, setdetails] = useState()
  const [officerForm, setofficerForm] = useState()
  const [serviceType, setserviceType] = useState()

  useEffect(() => {
    setofficerForm(
      <OfficerForm loading={false} appDetails={props.appDetails} />
    )
    if (props.appDetails.basel_convention) {
      setdetails(<DetailsBasel appDetails={props.appDetails} />)
    } else if (props.appDetails.auth_plastic_bags) {
      setdetails(<DetailsPlasticBags appDetails={props.appDetails} />)
      setserviceType("auth-plastics")
    } else if (props.appDetails.guidance_disposal) {
      setofficerForm(<OfficerFormLicense appDetails={props.appDetails} />)
      setdetails(<DisposalDetails appDetails={props.appDetails} />)
    } else if (props.appDetails.delivery_partner_service_request) {
      setofficerForm(
        <OfficerFormDeliveryPartner appDetails={props.appDetails} />
      )
      setdetails(<DetailsDeliveryPartner appDetails={props.appDetails} />)
      setserviceType("delivery-partner")
    } else if (props.appDetails.accreditation_request) {
      setofficerForm(<OfficerFormAccreditation appDetails={props.appDetails} />)
      setdetails(<DetailsAccreditation appDetails={props.appDetails} />)
      setserviceType("accreditation-request")
    } else if (props.appDetails.no_objection_letter_request) {
      setofficerForm(<OfficerFormNoObjection appDetails={props.appDetails} />)
      setdetails(<DetailsNoObjection appDetails={props.appDetails} />)
      setserviceType("no-objection")
    } else if (props.appDetails.environmental_audit_request) {
      setofficerForm(
        <OfficerFormEnvironmentalAudit appDetails={props.appDetails} />
      )
      setdetails(<DetailsEnvironmentalAudit appDetails={props.appDetails} />)
      setserviceType("environmental-audit")
    } else {
      setofficerForm(<OfficerFormLicense appDetails={props.appDetails} />)
      setdetails(<DetailsRotterdam appDetails={props.appDetails} />)
    }
  }, [])

  async function submitReview(values) {
    if (confirm("Do you want to proceed with selected decision?")) {
      setofficerForm(
        <OfficerForm loading={true} appDetails={props.appDetails} />
      )
      // modify manually processed
      if (
        values.manually_processed != undefined &&
        values.manually_processed == "yes"
      ) {
        values = { ...values, manually_processed: true }
      } else {
        values = { ...values, manually_processed: false }
      }

      let response = await reviewController.reviewOfficer(values)
      if (response.status) {
        if (serviceType == "auth-plastics") {
          setofficerForm(
            <OfficerForm
              loading={false}
              success={true}
              message={response.message}
              appDetails={props.appDetails}
            />
          )
        }
        if (serviceType == "delivery-partner") {
          setofficerForm(
            <OfficerFormDeliveryPartner
              loading={false}
              success={true}
              message={response.message}
              appDetails={props.appDetails}
            />
          )
        }
        if (serviceType == "accreditation-request") {
          setofficerForm(
            <OfficerFormAccreditation
              loading={false}
              success={true}
              message={response.message}
              appDetails={props.appDetails}
            />
          )
        }
        if (serviceType == "no-objection") {
          setofficerForm(
            <OfficerFormNoObjection
              loading={false}
              success={true}
              message={response.message}
              appDetails={props.appDetails}
            />
          )
        }
        if (serviceType == "environmental-audit") {
          setofficerForm(
            <OfficerFormEnvironmentalAudit
              loading={false}
              success={true}
              message={response.message}
              appDetails={props.appDetails}
            />
          )
        }
      } else {
        // console.log(response)
        if (serviceType == "auth-plastics") {
          setofficerForm(
            <OfficerForm
              loading={false}
              error={true}
              message={response.message}
              appDetails={props.appDetails}
            />
          )
        }
        if (serviceType == "delivery-partner") {
          setofficerForm(
            <OfficerFormDeliveryPartner
              loading={false}
              error={true}
              message={response.message}
              appDetails={props.appDetails}
            />
          )
        }
        if (serviceType == "accreditation-request") {
          setofficerForm(
            <OfficerFormAccreditation
              loading={false}
              error={true}
              message={response.message}
              appDetails={props.appDetails}
            />
          )
        }
        if (serviceType == "no-objection") {
          setofficerForm(
            <OfficerFormNoObjection
              loading={false}
              error={true}
              message={response.message}
              appDetails={props.appDetails}
            />
          )
        }
        if (serviceType == "environmental-audit") {
          setofficerForm(
            <OfficerFormEnvironmentalAudit
              loading={false}
              error={true}
              message={response.message}
              appDetails={props.appDetails}
            />
          )
        }
      }
    }
  }

  return (
    <>
      <BaseApplication
        title="Review Application"
        attachments={props.appDetails.application_attachments}
        appDetails={details}
        submit={submitReview}
        formComponent={officerForm}
        applicationData={props.appDetails}
      />
    </>
  )
}

export default ReviewOfficerExport
